import React from 'react'

import { Button, theme } from '@acorns/grove'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

const Badge = styled(Button)`
  background-color: ${theme.colors.primarySlate};
  border-radius: 100px;
  color: ${theme.colors.primaryWhite};
  cursor: pointer;
  font-size: 12px;
  font-weight: ${theme.fontWeight.demiBold};
  height: 36px;
  line-height: 16px;
  padding: 0 20px;
  white-space: nowrap;
  width: fit-content;

  :hover {
    background-color: ${theme.colors.primarySlate};
  }
`

const Options = styled.ul`
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  list-style: none;
  margin: 0;
  overflow-x: auto;
  position: absolute;
  right: 20px;
`

const RecommendedSearchTerms = ({
  hasChatHistory,
  searchTerms,
  onClickRecommendedSearchTerm,
  onClickChatHistory,
}: {
  hasChatHistory: boolean
  searchTerms: string[]
  onClickRecommendedSearchTerm: (searchTerm: string) => () => void
  onClickChatHistory: () => void
}) => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <Options>
      {hasChatHistory ? (
        <li key="chat-history">
          <Badge onClick={onClickChatHistory}>
            {getRemoteString({
              key: 'ai_assistant.chat.search_terms.chat_history',
            })}
          </Badge>
        </li>
      ) : null}
      {searchTerms?.map((searchTerm: string) => (
        <li key={searchTerm}>
          <Badge onClick={onClickRecommendedSearchTerm(searchTerm)}>
            {searchTerm}
          </Badge>
        </li>
      ))}
    </Options>
  )
}

export { RecommendedSearchTerms }
